import Debug from '../../helpers/debug.js';
import ora from 'ora';
import axios from 'axios';
import Table from 'cli-table';
import descriptions from '../../helpers/descriptions.js';
import { pr, pp, cl, themed, printJSON } from '../../helpers/print.js';

const debug = (...args) => {
  const debug = Debug('commands:jobs:list');
  debug(...args);
};

const command = 'list';

const desc = 'List jobs';

const builder = async (yargs) => {
  debug('builder', command);

  return yargs
    .option('flow', descriptions.options['flow'].config)
    .demandOption('flow', descriptions.options['flow'].demandText)
    .option('tenant', { ...descriptions.options['tenant'].config, default: 'default' })
    .option('count', descriptions.options['count'].config);
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { hg, json, apikey, env, flow, tenant, count } = argv;
  const { clientApiBaseUri } = hg;

  let message;
  let spinner = ora();
  try {
    // 1. get data from client-api backend
    message = themed(
      `Retrieving jobs for environment: ${themed(env, 'info')} flow: ${themed(flow, 'info')} tenant: ${themed(
        tenant,
        'info'
      )}...`
    );
    const uri = `${clientApiBaseUri}/${env}/${flow}/${tenant}/jobs${count ? `?count=${count}` : ''}`;
    debug('requesting:', uri);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));
    const { data } = await axios.get(uri, { headers: { 'x-api-key': apikey } });
    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));
    debug('response-data', data);

    // exit if there is no data
    if (!data || data.length === 0) {
      json
        ? printJSON([])
        : spinner.warn(
            themed(`Warning: ${themed('No jobs for the specified environment, flow and tenant')}.`, 'secondary')
          );
      return;
    }

    if (json) {
      printJSON(data);
    } else {
      // generate results table
      const table = new Table({ head: ['name', 'details'] });
      data.forEach((item) => table.push([item.job_name, JSON.stringify(item, undefined, 2)]));
      // print results
      console.log(table.toString());
    }
  } catch (err) {
    if (json) {
      printJSON({ status: 'error', error: err });
    } else {
      spinner.fail(themed(`Error: ${message}.`, 'secondary'));
      pr(themed(`Message: ${themed(err.message)}`, 'secondary'));
      debug(err);
      if (err && err.response && err.response.data) {
        debug('response', err.response.data);
      }
    }
  }
};

export { command, desc, builder, handler };
